const initialState = {
    AllEchFRS: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "Echfrs_GET":
        return {
          ...state,
          AllEchFRS: action.payload,
        };
      default:
        return state;
    }
  }
  